<div class="gift-donation row" *ngIf="giftDonationMode == 'mandatory' || giftDonationMode == 'optional'">
	<div class="column small-12" *ngIf="giftDonationMode == 'optional'">
		<label>{{ "gift.label" | translate }}</label>
	</div>
	<div class="column small-12 checkboxbutton-wrapper" [formGroup]="form" *ngIf="giftDonationMode == 'optional'">
		<input type="checkbox" [(ngModel)]="donation.giftData.isGiftDonation" name="gift.isGiftDonation" value="1" id="isGiftDonation" formControlName="gift.isGiftDonation" (change)="toggleShowGiftdonationData()">
		<label for="isGiftDonation"><span><i class="twingle-{{ icon }}"></i> {{'gift.isGiftDonation' | translate}}</span></label>
	</div>
	<div class="column small-12" *ngIf="donation.giftData.isGiftDonation === true">
		<p class="label">
			{{ "gift.teaser" | translate }}
		</p>
	</div>
	<ng-container *ngIf="giftDonationMode == 'mandatory' || donation.giftData.isGiftDonation === true">
		<textfield [(model)]="donation.giftData.sender" [fieldType]="'text'" [name]="'gift.sender'" [label]="'gift.sender.label' | translate" [error]="'gift.sender.error' | translate" [required]="true" [wrapperClass]="'columns small-12 medium-6'" [form]="form"></textfield>
		<textfield [(model)]="donation.giftData.receiver" [fieldType]="'text'" [name]="'gift.receiver'" [label]="'gift.receiver.label' | translate" [error]="'gift.receiver.error' | translate" [required]="true" [wrapperClass]="'columns small-12 medium-6'" [form]="form"></textfield>
	</ng-container>

</div>
